<template>
  <div class="review-row d-flex align-center py-2">
    <span class="text-body-2 text-medium-emphasis review-row__label"
      >{{ label
      }}<span
        v-if="required"
        class="text-error"
        aria-hidden="true"
      >
        *</span
      ></span
    >

    <v-select
      v-if="editable && type === 'select'"
      :model-value="value"
      :items="items"
      class="review-row__control"
      variant="outlined"
      density="compact"
      rounded="lg"
      hide-details
      clearable
      :placeholder="placeholder"
      @update:model-value="$emit('update:value', $event ?? '')"
    />
    <v-text-field
      v-else-if="editable"
      :model-value="value"
      class="review-row__control"
      variant="outlined"
      density="compact"
      rounded="lg"
      hide-details="auto"
      :placeholder="placeholder"
      :rules="rules"
      @update:model-value="$emit('update:value', $event ?? '')"
    />
    <span
      v-else
      class="text-body-2 font-weight-medium"
      >{{ value || '—' }}</span
    >
  </div>
</template>

<script setup lang="ts">
type SelectItem = { title: string; value: string }

withDefaults(
  defineProps<{
    label: string
    value?: string
    editable?: boolean
    type?: 'text' | 'select'
    items?: SelectItem[]
    placeholder?: string
    rules?: Array<(v: string) => true | string>
    /** Shows a required-field asterisk after the label. */
    required?: boolean
  }>(),
  {
    value: '',
    editable: false,
    type: 'text',
    items: () => [],
    placeholder: '',
    rules: () => [],
  }
)

defineEmits<{
  'update:value': [value: string]
}>()
</script>

<style scoped>
.review-row {
  border-bottom: 1px solid rgba(var(--v-border-color), 0.06);
  gap: 16px;
}

.review-row:last-child {
  border-bottom: none;
}

.review-row__label {
  min-width: 160px;
  flex-shrink: 0;
}

.review-row__control {
  flex: 1;
  min-width: 0;
}
</style>
